var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import { getTestSelector } from '../../../utilities/tests';
import { getTextButtonSizeClass, TextButtonSize } from './TextButton.helpers';
export default function TextButton(_a) {
    var children = _a.children, _b = _a.type, type = _b === void 0 ? 'button' : _b, className = _a.className, disabled = _a.disabled, _c = _a.testSelector, testSelector = _c === void 0 ? getTestSelector(typeof children === 'string' ? children : 'not-identified', 'button') : _c, _d = _a.size, size = _d === void 0 ? TextButtonSize.Medium : _d, rest = __rest(_a, ["children", "type", "className", "disabled", "testSelector", "size"]);
    return (_jsx("button", __assign({ className: clsx('text-blue-500 transition-all hover:saturate-[1.4]', className, getTextButtonSizeClass(size)), type: type, disabled: disabled, "data-cy": testSelector }, rest, { children: children })));
}
